export function UUID() {
  const randomHex = () => Math.floor(Math.random() * 16).toString(16)

  const generateBlock = length => Array.from({ length }, randomHex).join('')

  return `${generateBlock(8)}-${generateBlock(4)}-4${generateBlock(
    3
  )}-${randomHex(Math.floor(Math.random() * 4 + 8))}${generateBlock(3)}-${generateBlock(12)}`
}
